import { render, staticRenderFns } from "./SporadicCharges.vue?vue&type=template&id=66f958ca&scoped=true&"
import script from "./SporadicCharges.vue?vue&type=script&lang=js&"
export * from "./SporadicCharges.vue?vue&type=script&lang=js&"
import style0 from "./SporadicCharges.vue?vue&type=style&index=0&id=66f958ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f958ca",
  null
  
)

export default component.exports